<template>
    <span class="flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-luuqa/15 text-xs font-semibold uppercase text-luuqa">
        <img v-if="url" :src="url" alt="" loading="lazy" class="h-full w-full object-cover" />
        <template v-else>{{ (name || "?").charAt(0) }}</template>
    </span>
</template>
<script>
export default {
    name: "LuuqaAvatar",
    props: {
        url: String,
        name: String,
    },
};
</script>
